// #642 — THE app: one live, time-ordered running order for ONE ring.
//
// Read-only by construction. The announcer never writes a score, never changes a
// status, never touches FVD — which is what keeps this screen small.
//
// Freshness (#3557, docs/adr/0003): the announcer reloads only when something
// changed. ONE cheap GET /show/:id/changes per beat (useShowChangeCheck) says
// whether anything moved; only then are this ring's rides / breaks / classes /
// statuses / ring-state / results summary read again, with GET /ride?ring so
// one ring is read, not the whole show. A 60 s backstop refreshes everything
// regardless. A quiet ring therefore costs one read per beat instead of ~2,880
// reads/hr/terminal (the old blind 5 s re-read of every list). Two polls keep
// their own timers: useClassResults' live-class results poll and the presence
// poll. people/horses stay on their own one-shot fetch (useRoster.js).
export const STATUS_POLL_MS = 5000;
export const ENTITY_POLL_MS = 5000;
// #645 — how long the screen can go without a successful status refresh
// before it stops calling itself "live", even while `online` is still true.
// A single missed poll (a blip) shouldn't flash the banner; four missed polls
// (STATUS_POLL_MS * 4) means something's actually wrong upstream.
export const STALE_THRESHOLD_MS = STATUS_POLL_MS * 4;
// How often the banner's own clock re-checks staleness / re-renders its
// "HH:MM" text. Independent of the entity/status polls — this never touches
// the network, it just re-evaluates wall-clock math.
export const CLOCK_TICK_MS = 10000;
// #691 — the sticky header's live clock + countdown want a proper ticking
// feel, so they get their own faster tick, separate from the freshness
// banner's coarser one above. Still fetches nothing — pure wall-clock math.
export const LIVE_TICK_MS = 1000;

// #3557 -- the change check. One cheap GET /show/:id/changes per beat decides
// whether anything on screen needs reading again (docs/adr/0003). The server
// recommends the beat (`pollMs`); DEFAULT is the fallback when the answer
// carries none, MIN the floor that stops a bad value becoming a hot loop (the
// server floors its own at 1000 too).
export const DEFAULT_CHANGE_POLL_MS = 5000;
export const MIN_CHANGE_POLL_MS = 1000;
// Safety net: even if the change check says nothing moved (or keeps failing),
// the screen re-reads everything this often. Bounds how long a missed signal
// can leave the announcer wrong.
export const BACKSTOP_REFRESH_MS = 60000;
